import React, { FC } from 'react';
import styled from 'styled-components';
import { MangoBlue, MarineBlue, White } from '../../styles/colours';
import { DemiBold } from '../../styles/fonts';

const StyledCustomerType = styled.div<any>`
  display: inline-block;
  height: 1.5rem;
  line-height: 1.5rem;
  padding: 0 1rem;
  border-radius: 4px;
  font-family: ${DemiBold};
  font-size: 0.8rem;

  color: ${White};
  background: ${({ type }: any) =>
    type === 'Sold-To' ? MangoBlue : MarineBlue};
`;

export type CustomerTypes = 'Sold-To' | 'Ship-To';

export interface ICustomerType {
  type: CustomerTypes;
}

export const CustomerType: FC<ICustomerType> = ({ type }) => {
  return (
    <StyledCustomerType type={type} data-type="customer-type" data-value={type}>
      {type}
    </StyledCustomerType>
  );
};

export const SoldToCustomerType = () => {
  return (
    <StyledCustomerType data-type="customer-type">Sold-To</StyledCustomerType>
  );
};

export const ShipToCustomerType = () => {
  return (
    <StyledCustomerType data-type="customer-type">Ship-To</StyledCustomerType>
  );
};
